<script>
import {BFormGroup} from 'bootstrap-vue'
import VuePhoneNumberInput from 'vue-phone-number-input';
export default {
    components: {BFormGroup, VuePhoneNumberInput},
    props: {
        defaultCountryCode: {
            default: null
        },
        phone: {
            default: null
        },
        required: {
            default: true
        }
    },
    data() {
        return {
            phoneNumber: this.phone,
            isPhoneInValid: false
        };
    },
    methods: {
        onPhoneSet(data) {
            this.isPhoneInValid = !data.isValid;
            this.$emit('input', {
                isValid: data.isValid,
                countryPhoneCode: data.countryCallingCode,
                formatInternational: data.formatInternational,
                formatted: data.formattedNumber,
                countryCode: data.countryCode
            })
        },
    },
    computed: {
        phoneNumberTranslations() {
            return {
                countrySelectorLabel: this.$t('Component(VuePhoneNumberInput):country-selector-label'),
                countrySelectorError: this.$t('Component(VuePhoneNumberInput):country-selector-error'),
                phoneNumberLabel: this.$t('Component(VuePhoneNumberInput):phone-number-label'),
                // example: this.$t('Component(VuePhoneNumberInput):phone-example')
            };
        }
    },
    watch: {
        phone() {
            this.phoneNumber = this.phone;
        }
    }
}
</script>

<template>
    <b-form-group
        :label="$t('Component(Label):phone')"
        label-for="phone"
        class="phone-label"
    >
        <VuePhoneNumberInput
            id="phone"
            v-model="phoneNumber"
            :translations="phoneNumberTranslations"
            color="#ff9f43"
            dark-color="#303144"
            no-validator-state
            :required="required"
            :default-country-code="defaultCountryCode"
            :error="isPhoneInValid"
            @update="onPhoneSet"
        />
    </b-form-group>
</template>

<style scoped lang="scss">

</style>
